// Quality-tier color/pill styler (Phase 5 leaf module). 6 tiers, lightest→deepest.
// NOTE: emits Tailwind classes (text-indigo-300, bg-indigo-500/[12%], ...) — tailwind.config content
// must scan src/**/*.js so these aren't purged.
export const QS = (() => {
    // 6 tiers, lightest→deepest. Indigo = elite, then emerald→teal for good,
    // slate for neutral, amber→rose for weak/poor.
    const TIERS = [
        { min: 0.90, text: 'text-indigo-300',  bold: true,  pill: 'bg-indigo-500/[12%] border-indigo-400/40 text-indigo-200' },
        { min: 0.75, text: 'text-emerald-300', bold: true,  pill: 'bg-emerald-500/[12%] border-emerald-400/40 text-emerald-200' },
        { min: 0.60, text: 'text-teal-300',    bold: false, pill: 'bg-teal-500/10 border-teal-400/30 text-teal-200' },
        { min: 0.42, text: 'text-slate-300',   bold: false, pill: 'bg-slate-700/40 border-slate-600/60 text-slate-200' },
        { min: 0.25, text: 'text-amber-300',   bold: false, pill: 'bg-amber-500/10 border-amber-400/30 text-amber-200' },
        { min: -1,   text: 'text-rose-300',    bold: false, pill: 'bg-rose-500/10 border-rose-400/30 text-rose-200' }
    ];
    const pick = (pct) => {
        if (!Number.isFinite(pct)) return null;
        for (const t of TIERS) if (pct >= t.min) return t;
        return TIERS[TIERS.length - 1];
    };
    return {
        // text colour for a value out of `max`
        text(value, max = 100) {
            const t = pick(max > 0 ? value / max : NaN);
            if (!t) return 'text-slate-600';
            return t.text + (t.bold ? ' font-bold' : '');
        },
        // pill (bg+border+text) for a value out of `max`
        bg(value, max = 100) {
            const t = pick(max > 0 ? value / max : NaN);
            return t ? t.pill : 'bg-slate-800/40 border-slate-700 text-slate-500';
        },
        // direct tier by normalized pct (0–1)
        textPct(pct) { const t = pick(pct); return t ? t.text + (t.bold ? ' font-bold' : '') : 'text-slate-600'; }
    };
})();
